import Container from './container'
import Content from './content'
import Option from './option'
import Search from './search'

const HeaderComponents = {
    Container, Content, Option, Search
}

export default HeaderComponents